import React, {Component} from "react"

import {
  AppBar,
  Button,
  MenuList,
  MenuListItem,
  Toolbar,
  Window,
  WindowContent,
  WindowHeader,
  Separator,
  Frame,
  ScrollView,
} from 'react95'

import WindowPortfolio from './WindowPortfolio';
import WindowAbout from './WindowAbout';
import WindowContact from './WindowContact';
import WindowSettings from './WindowSettings';
import WindowShop from './WindowShop';

import Draggable from 'react-draggable';

import { t } from './i18n';

class WindowHome extends Component {
	constructor(props){
		super(props)
		this.state = {
      contact: false,
      about: false,
      portfolio: false,
      settings: false,
      shop: false,
      home: true,
      zCounter: 10,
      zIndex: { home: 10, contact: 0, about: 0, portfolio: 0, settings: 0, shop: 0 },
      focusedWindow: 'home',
      contextMenu: null,
      desktopContextMenu: null,
      selectedIcon: null,
      showShopIcon: window.location.hash === '#shop',
      clock: this.formatTime(),
    }
	}

  handleClickIconOnlineCreation = () => {
    this.setState({ selectedIcon: 'onlinecreation' });
  };

  handleDoubleClickIconOnlineCreation = () => {
    if (this.state.home) {
      this.bringToFront('home')
      return
    }
    this.setState(() => ({home: true}), () => {
      this.bringToFront('home')
    })
  }
  handleClickIconPortfolio = () => {
    this.setState({ selectedIcon: 'portfolio' });
  };
  handleDoubleClickIconPortfolio = () => {
    this.openWindow('portfolio');
  }
  handleClickIconContact = () => {
    this.setState({ selectedIcon: 'contact' });
  };
  handleDoubleClickIconContact = () => {
    this.openContact();
  }
  handleClickIconSettings = () => {
    this.setState({ selectedIcon: 'settings' });
  };
  handleDoubleClickIconSettings = () => {
    this.openSettings();
  }

  handleClickIconShop = () => {
    this.setState({ selectedIcon: 'shop' });
  };
  handleDoubleClickIconShop = () => {
    this.openShop();
  }

  deselectIcons = () => {
    this.setState({ selectedIcon: null });
  }

  openContact = () => {
    if (this.state.contact) {
      this.bringToFront('contact')
      return
    }
    this.setState(() => ({contact: true}), () => {
      this.bringToFront('contact')
    })
  }
  openAbout = () => {
    if (this.state.about) {
      this.bringToFront('about')
      return
    }
    this.setState(() => ({about: true}), () => {
      this.bringToFront('about')
    })
  }
  openPortfolio = () => {
    if (this.state.portfolio) {
      this.bringToFront('portfolio')
      return
    }
    this.setState(() => ({portfolio: true}), () => {
      this.bringToFront('portfolio')
    })
  }
  openSettings = () => {
    if (this.state.settings) {
      this.bringToFront('settings')
      return
    }
    this.setState(() => ({settings: true}), () => {
      this.bringToFront('settings')
    })
  }
  openShop = () => {
    if (this.state.shop) {
      this.bringToFront('shop')
      return
    }
    this.setState(() => ({shop: true}), () => {
      this.bringToFront('shop')
    })
  }
  openWindow (win) {
    switch(win) {
      case 'contact':
        this.openContact()
        break;
      case 'about':
        this.openAbout()
        break;
      case 'portfolio':
        this.openPortfolio()
        break;
      case 'settings':
        this.openSettings()
        break;
      case 'shop':
        this.openShop()
        break;
      default:
        console.error('This window does not exist')
    }
  }
  closeContact = () => {
    window.scrollTo(0, 0)
    this.setState(() => ({contact: false}), () => {
      this.focusTopWindow()
    })
  }
  closeAbout = () => {
    window.scrollTo(0, 0)
    this.setState(() => ({about: false}), () => {
      this.focusTopWindow()
    })
  }
  closePortfolio = () => {
    window.scrollTo(0, 0)
    this.setState(() => ({portfolio: false}), () => {
      this.focusTopWindow()
    })
  }
  closeSettings = () => {
    window.scrollTo(0, 0)
    this.setState(() => ({settings: false}), () => {
      this.focusTopWindow()
    })
  }
  closeShop = () => {
    window.scrollTo(0, 0)
    this.setState(() => ({shop: false}), () => {
      this.focusTopWindow()
    })
  }
  formatTime() {
    const now = new Date()
    return now.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
  }
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown)
    document.addEventListener('click', this.handleGlobalClick)
    document.addEventListener('contextmenu', this.handleDesktopContextMenu)
    document.addEventListener('touchstart', this.handleTouchStartForSelect, { passive: true })
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('orientationchange', this.handleResize)
    // if URL ends with 9-legal.html, open About
    // if URL ends with #contact, open Contact
    // if URL ends with #realisations, open Portfolio
    if (window.location.href.indexOf('#contact') > -1) {
      this.openContact()
    }
    if (window.location.href.indexOf('#realisations') > -1) {
      this.openPortfolio()
    }
    if (window.location.href.indexOf('9-legal.html') > -1) {
      this.openAbout()
    }
    if (window.location.hash === '#shop') {
      this.setState({ showShopIcon: true })
      this.openShop()
    }
    window.addEventListener('hashchange', this.handleHashChange)
    setTimeout(() => {
      this.centerWindows()
    }, 100)
    this.clockTimer = setInterval(() => {
      this.setState({clock: this.formatTime()})
    }, 10000)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown)
    document.removeEventListener('click', this.handleGlobalClick)
    document.removeEventListener('contextmenu', this.handleDesktopContextMenu)
    document.removeEventListener('touchstart', this.handleTouchStartForSelect)
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('orientationchange', this.handleResize)
    window.removeEventListener('hashchange', this.handleHashChange)
    if (this.clockTimer) clearInterval(this.clockTimer)
  }
  
  handleResize = () => {
    this.clampAllWindows()
    this.centerWindows()
  }

  handleHashChange = () => {
    if (window.location.hash === '#shop') {
      this.setState({ showShopIcon: true })
      this.openShop()
    }
  }

  clampAllWindows = () => {
    const vw = window.innerWidth
    const vh = window.innerHeight - 36
    document.querySelectorAll('.windows-container .window').forEach((win) => {
      const rect = win.getBoundingClientRect()
      let newLeft = rect.left
      let newTop = rect.top
      if (rect.right > vw) newLeft = Math.max(0, vw - rect.width)
      if (rect.bottom > vh) newTop = Math.max(0, vh - rect.height)
      if (rect.left < 0) newLeft = 0
      if (rect.top < 0) newTop = 0
      if (newLeft !== rect.left || newTop !== rect.top) {
        const transform = `translate(${newLeft - (parseFloat(win.style.left) || 0)}px, 0px)`
        win.style.transform = transform
        if (newTop !== rect.top) {
          win.style.top = newTop + 'px'
        }
      }
    })
  }

  handleGlobalClick = (e) => {
    if (!e.target.closest('.icon-desktop')) {
      this.deselectIcons()
    }
    if (this.state.contextMenu && !e.target.closest('.context-menu-wrapper')) {
      this.setState({contextMenu: null})
    }
    if (this.state.desktopContextMenu && !e.target.closest('.context-menu-wrapper')) {
      this.setState({desktopContextMenu: null})
    }
  }

  handleTouchStartForSelect = (e) => {
    const option = e.target.closest('[role="option"]');
    if (option) {
      option.dispatchEvent(new MouseEvent('mouseover', { bubbles: true, cancelable: true }));
    }
  }

  handleDesktopContextMenu = (e) => {
    if (e.target.closest('.window') || e.target.closest('header') || e.target.closest('.context-menu-wrapper')) return;
    e.preventDefault()
    this.setState({
      desktopContextMenu: { x: e.clientX, y: e.clientY },
      contextMenu: null
    })
  }

  centerWindows () {
    const containerHeight = window.innerHeight - 37
    const containerWidth = window.innerWidth
    document.querySelectorAll('.center-window').forEach((win) => {
      if (win.offsetHeight >= containerHeight) {
        win.style.top = '0px'
      } else {
        win.style.top = (containerHeight - win.offsetHeight)/2 + 'px'
      }
      if (win.offsetWidth < containerWidth) {
        win.style.left = (containerWidth - win.offsetWidth)/2 + 'px'
      } else {
        win.style.left = '0px'
      }
    })
  }

  bringToFront = (windowName) => {
    this.setState((prevState) => {
      const newCounter = prevState.zCounter + 1
      return {
        zCounter: newCounter,
        zIndex: { ...prevState.zIndex, [windowName]: newCounter },
        focusedWindow: windowName
      }
    })
  }

  focusTopWindow = () => {
    const { home, contact, about, portfolio, settings, shop, zIndex } = this.state
    const windows = []
    if (home) windows.push({ name: 'home', z: zIndex.home })
    if (contact) windows.push({ name: 'contact', z: zIndex.contact })
    if (about) windows.push({ name: 'about', z: zIndex.about })
    if (portfolio) windows.push({ name: 'portfolio', z: zIndex.portfolio })
    if (settings) windows.push({ name: 'settings', z: zIndex.settings })
    if (shop) windows.push({ name: 'shop', z: zIndex.shop })
    if (windows.length > 0) {
      windows.sort((a, b) => b.z - a.z)
      this.setState({ focusedWindow: windows[0].name })
    }
  }

  cycleWindows = () => {
    const openWindows = []
    if (this.state.home) openWindows.push('home')
    if (this.state.contact) openWindows.push('contact')
    if (this.state.about) openWindows.push('about')
    if (this.state.portfolio) openWindows.push('portfolio')
    if (this.state.settings) openWindows.push('settings')
    if (this.state.shop) openWindows.push('shop')
    if (openWindows.length <= 1) return
    const currentIndex = openWindows.indexOf(this.state.focusedWindow)
    const nextIndex = (currentIndex + 1) % openWindows.length
    this.bringToFront(openWindows[nextIndex])
  }

  handleKeyDown = (e) => {
    if (e.altKey && e.key === 'Tab') {
      e.preventDefault()
      this.cycleWindows()
    }
  }

  closeWindowHome = () => {
    this.setState({home: false}, () => {
      this.focusTopWindow()
    })
  }

  handleTaskbarClick = (windowName) => {
    this.bringToFront(windowName)
  }

  handleTaskbarContextMenu = (e, windowName) => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({contextMenu: {x: e.clientX, windowName}, desktopContextMenu: null})
  }

  closeWindowFromTaskbar = (windowName) => {
    this.setState({contextMenu: null})
    switch(windowName) {
      case 'home': this.closeWindowHome(); break;
      case 'contact': this.closeContact(); break;
      case 'about': this.closeAbout(); break;
      case 'portfolio': this.closePortfolio(); break;
      case 'settings': this.closeSettings(); break;
      case 'shop': this.closeShop(); break;
      default: break;
    }
  }

  getOpenWindows = () => {
    const lang = this.props.lang
    const wins = []
    if (this.state.home) wins.push({id: 'home', title: t('homeTitle', lang), icon: 'fak fa-onlinecreation'})
    if (this.state.contact) wins.push({id: 'contact', title: t('contactTitle', lang), iconImg: 'png/Mail_16x16_4.png'})
    if (this.state.about) wins.push({id: 'about', title: t('aboutTitle', lang), iconClass: 'Help_16x16_4'})
    if (this.state.portfolio) wins.push({id: 'portfolio', title: t('portfolioTitle', lang), iconClass: 'Websrch_16x16_4'})
    if (this.state.settings) wins.push({id: 'settings', title: t('settingsTitle', lang), iconClass: 'Settings_16x16_4'})
    if (this.state.shop) wins.push({id: 'shop', title: t('shopTitle', lang), iconClass: 'Computer_16x16_4'})
    return wins
  }

	render(){
    const lang = this.props.lang
    const openWindows = this.getOpenWindows()
    return (
      <>
          <div className="icon-container icon-container-1">
            <div className={`icon-desktop icon-onlinecreation ${this.state.selectedIcon === 'onlinecreation' ? 'active' : ''}`} onClick={this.handleClickIconOnlineCreation} onDoubleClick={this.handleDoubleClickIconOnlineCreation}>
              <span>{t('iconOnlineCreation', lang)}</span>
            </div>
          </div>
          <div className="icon-container icon-container-2">
            <div className={`icon-desktop icon-contact ${this.state.selectedIcon === 'contact' ? 'active' : ''}`} onClick={this.handleClickIconContact} onDoubleClick={this.handleDoubleClickIconContact}>
              <span>{t('iconContact', lang)}</span>
            </div>
          </div>
          <div className="icon-container icon-container-3">
            <div className={`icon-desktop icon-portfolio ${this.state.selectedIcon === 'portfolio' ? 'active' : ''}`} onClick={this.handleClickIconPortfolio} onDoubleClick={this.handleDoubleClickIconPortfolio}>
              <span>{t('portfolioTitle', lang)}</span>
            </div>
          </div>
          <div className="icon-container icon-container-4">
            <div className={`icon-desktop icon-settings ${this.state.selectedIcon === 'settings' ? 'active' : ''}`} onClick={this.handleClickIconSettings} onDoubleClick={this.handleDoubleClickIconSettings}>
              <span>{t('settingsTitle', lang)}</span>
            </div>
          </div>
          {this.state.showShopIcon && <div className="icon-container icon-container-5">
            <div className={`icon-desktop icon-shop ${this.state.selectedIcon === 'shop' ? 'active' : ''}`} onClick={this.handleClickIconShop} onDoubleClick={this.handleDoubleClickIconShop}>
              <span>{t('iconShop', lang)}</span>
            </div>
          </div>}
          <div className="windows-container window-home">
            {this.state.home && <Draggable bounds="parent" handle=".draggable-title">
              <Window className='main-window window center-window' style={{zIndex: this.state.zIndex.home}} onMouseDownCapture={() => this.bringToFront('home')}>
                <WindowHeader className={`window-title${this.state.focusedWindow === 'home' ? '' : ' inactive'}`}>
                  <div className="float-right">
                    <Button onClick={this.closeWindowHome}>
                      &times;
                    </Button>
                  </div>

                  <div className="draggable-title">
                    <i className="fak fa-onlinecreation"></i><span> {t('homeTitle', lang)}</span>
                  </div>
                </WindowHeader>
                <WindowContent>
                  <div className="bottom-8" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div className="User5_32x32_4 transform-2x all-16 inline-block vertical-middle visible-xs"></div> 
                    <Frame variant='field' className="hidden-xs right-16" style={{ flex: 1 }} >
                      <div className="wizard-preview"></div>
                    </Frame>
                    <div className="" style={{ flex: 2 }} >
                      <p className="text-lg left-8 bottom-8">
                        <strong>{t('homeHeadline', lang)}</strong>
                      </p>
                      <p className="text-lg left-8">
                        <strong>OnlineCreation</strong> {t('homeDescription', lang)}
                      </p>
                      <ul className="left-32">
                        <li style={{listStyle: 'square'}}>{t('homeWebsite', lang)}</li>
                        <li style={{listStyle: 'square'}}>{t('homeMobileApp', lang)}</li>
                        <li style={{listStyle: 'square'}}>{t('homeEcommerce', lang)}</li>
                      </ul>
                    </div>
                  </div>
                  <Separator className="hidden-xs" />
                  
                  <p className='align-right'>
                    <Button size='lg' className="buttonLg" onClick={this.openContact}>{t('homeContact', lang)}</Button>
                    <Button size='lg' className="buttonLg" onClick={this.openAbout}>{t('homeAbout', lang)}</Button>
                    <Button size='lg' className="buttonLg" primary onClick={this.openPortfolio}>{t('homePortfolio', lang)}</Button>
                  </p>
                </WindowContent>
              </Window>
            </Draggable>}
            {this.state.contact && <WindowContact close={this.closeContact} openContact={this.openContact} centerWindows={this.centerWindows.bind(this)} zIndex={this.state.zIndex.contact} isFocused={this.state.focusedWindow === 'contact'} onFocus={() => this.bringToFront('contact')} lang={lang} />}
            {this.state.about && <WindowAbout close={this.closeAbout} openContact={this.openContact} centerWindows={this.centerWindows.bind(this)} zIndex={this.state.zIndex.about} isFocused={this.state.focusedWindow === 'about'} onFocus={() => this.bringToFront('about')} lang={lang} />}
            {this.state.portfolio && <WindowPortfolio close={this.closePortfolio} openContact={this.openContact} centerWindows={this.centerWindows.bind(this)} zIndex={this.state.zIndex.portfolio} isFocused={this.state.focusedWindow === 'portfolio'} onFocus={() => this.bringToFront('portfolio')} lang={lang} />}
            {this.state.settings && <WindowSettings close={this.closeSettings} centerWindows={this.centerWindows.bind(this)} zIndex={this.state.zIndex.settings} isFocused={this.state.focusedWindow === 'settings'} onFocus={() => this.bringToFront('settings')} lang={lang} wallpaper={this.props.wallpaper} onChangeWallpaper={this.props.onChangeWallpaper} onChangeLang={this.props.onChangeLang} />}
            {this.state.shop && <WindowShop close={this.closeShop} centerWindows={this.centerWindows.bind(this)} zIndex={this.state.zIndex.shop} isFocused={this.state.focusedWindow === 'shop'} onFocus={() => this.bringToFront('shop')} lang={lang} />}
          </div>
          {/* Taskbar */}
          <AppBar style={{ top: 'unset', bottom: 0, zIndex: 99998 }} onMouseDown={(e) => { if (!e.target.closest('button')) this.deselectIcons() }}>
            <Toolbar style={{ justifyContent: 'space-between', padding: '2px 4px' }}>
              <div style={{ display: 'flex', gap: 2, flex: 1, overflow: 'hidden', alignItems: 'flex-start' }}>
                {openWindows.map((win) => (
                  <Button
                    key={win.id}
                    active={this.state.focusedWindow === win.id}
                    onClick={() => this.handleTaskbarClick(win.id)}
                    onContextMenu={(e) => this.handleTaskbarContextMenu(e, win.id)}
                    style={{ display: 'flex', textAlign: 'left',alignItems: 'center', justifyContent: 'flex-start', gap: 4, width: 200, paddingLeft: 12, paddingRight: 12, fontWeight: this.state.focusedWindow === win.id ? 'bold' : 'normal' }}
                  >
                    {win.icon && <i className={win.icon} style={{fontSize: 14, width: 16, height: 16, flexShrink: 0}}></i>}
                    {win.iconImg && <img src={win.iconImg} alt="" style={{width: 16, height: 16, flexShrink: 0, imageRendering: 'crisp-edges'}} />}
                    {win.iconClass && <span className={win.iconClass} style={{transform: 'none', margin: 0, width: 16, height: 16, flexShrink: 0, imageRendering: 'crisp-edges'}}></span>}
                    <span style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{win.title}</span>
                  </Button>
                ))}
              </div>
              <ScrollView shadow={false} style={{ paddingLeft: 12, paddingRight: 12}}>{this.state.clock}</ScrollView>
            </Toolbar>
          </AppBar>
          {/* Taskbar context menu */}
          {this.state.contextMenu && (
            <div className="context-menu-wrapper" style={{position: 'fixed', left: this.state.contextMenu.x, bottom: 40, zIndex: 99999}}>
              <MenuList>
                <MenuListItem size='md' onClick={() => this.closeWindowFromTaskbar(this.state.contextMenu.windowName)}>
                  <span style={{marginRight: 8, display: 'inline-block', width: 16}}>&times;</span>
                  {t('taskbarClose', lang)}
                </MenuListItem>
              </MenuList>
            </div>
          )}
          {/* Desktop context menu */}
          {this.state.desktopContextMenu && (
            <div className="context-menu-wrapper" style={{position: 'fixed', left: this.state.desktopContextMenu.x, top: this.state.desktopContextMenu.y, zIndex: 99999}}>
              <MenuList>
                <MenuListItem size='md' onClick={() => { this.setState({desktopContextMenu: null}); this.openSettings(); }}>
                  <span className="Settings_16x16_4" style={{marginRight: 8, display: 'inline-block'}}></span>
                  {t('settingsTitle', lang)}
                </MenuListItem>
              </MenuList>
            </div>
          )}
      </>
    )
  }
}
export default WindowHome
